import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

const COLS = [
  { title: "Categories", links: [["Smart Shopping", "/smart-shopping/"], ["Home", "/home/"], ["Food", "/food/"], ["Travel", "/travel/"], ["Tech", "/tech/"], ["Everyday Tips", "/everyday-tips/"]] },
  { title: "Resources", links: [["Best Time to Buy", "/best-time-to-buy/"], ["Guides", "/guides/"], ["Comparisons", "/comparisons/"], ["Make It Last", "/make-it-last/"], ["Tools", "/tools/everyday-spending-checker/"]] },
  { title: "Company", links: [["About", "/about/"], ["Contact", "/contact/"], ["Editorial Policy", "/editorial-policy/"], ["Privacy", "/privacy/"], ["Terms", "/terms/"]] },
  { title: "Disclosures", links: [["Affiliate Disclosure", "/affiliate-disclosure/"], ["Advertising Disclosure", "/advertising-disclosure/"]] },
];

export const Footer = () => (
  <footer className="mt-24 border-t border-ab-border bg-ab-soft" data-testid="site-footer">
    <div className="container-ab grid gap-12 py-16 lg:grid-cols-12 lg:gap-8">
      <div className="lg:col-span-4">
        <div className="flex items-center gap-2.5">
          <LogoMark size={36} />
          <span className="font-serif text-2xl font-semibold tracking-tight">Article<span className="text-ab-accent">Blogs</span></span>
        </div>
        <p className="mt-4 max-w-xs font-serif text-lg italic text-ab-text-2">Everyday Tips for Smarter Living</p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-ab-muted">Practical ideas for spending less, wasting less, shopping smarter and living better. A consumer lifestyle publication.</p>
      </div>
      <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
        {COLS.map((c) => (
          <div key={c.title}>
            <h3 className="font-sans text-xs font-bold uppercase tracking-[0.14em] text-ab-text">{c.title}</h3>
            <ul className="mt-4 space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={to}><Link to={to} className="link-underline text-sm text-ab-text-2 hover:text-ab-text" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
    <div className="border-t border-ab-border">
      <div className="container-ab flex flex-col gap-2 py-6 text-xs text-ab-muted sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} ArticleBlogs.net. All rights reserved.</p>
        <p>Independent editorial. Some links may be affiliate links; see our disclosures.</p>
      </div>
    </div>
  </footer>
);
